// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesCtf = {
  ctfAuth: "CTF authentication",
  ctfDependency: "CTF dependency",
  ctfRuntime: "CTF runtime",
  ctfBusinessEvent: "CTF business event",
} as const;
